import script from "./SideBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideBar.vue?vue&type=script&lang=ts&setup=true"

import "./SideBar.vue?vue&type=style&index=0&id=f7f7bee6&lang=scss"

const __exports__ = script;

export default __exports__